'use es6';

import { flash } from 'DesignData/actions/Flash';
import { CUSTOM_WIDGET_BUFFER_REPLACE_TRANSLATION, CUSTOM_WIDGET_BUFFER_UPDATE_TRANSLATION, CUSTOM_WIDGET_BUFFER_UPDATE_MESSAGES } from 'DesignData/actions/ActionTypes';
import { LANGUAGE_EDITOR_LANGUAGE_REGENERATED } from 'DesignData/enums/FlashKeys';
export default (({
  dispatch
}) => next => action => {
  const result = next(action);

  switch (result.type) {
    case CUSTOM_WIDGET_BUFFER_REPLACE_TRANSLATION:
    case CUSTOM_WIDGET_BUFFER_UPDATE_TRANSLATION:
    case CUSTOM_WIDGET_BUFFER_UPDATE_MESSAGES:
      {
        dispatch(flash(LANGUAGE_EDITOR_LANGUAGE_REGENERATED, true));
        break;
      }

    default:
      break;
  }

  return result;
});